import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["orgBtn", "buyerBtn", "organisatorForm", "ticketkoperInfo"]

  connect() {
    // The visual card is the parent .form-card, not form-register
    this.formCard = this.element.closest('.form-card');
    if (this.formCard) {
      this.measureHeights();
    }
  }

  measureHeights() {
    // Hide password rules during measurement (they're dynamic content)
    const passwordRules = this.element.querySelector('[data-password-validation-target="rules"]');
    if (passwordRules) {
      passwordRules.style.display = 'none';
    }

    // Measure organisator (currently visible) - use scrollHeight for true content height
    this.orgHeight = this.formCard.scrollHeight;

    // Measure ticketkoper
    this.organisatorFormTarget.style.display = 'none';
    this.ticketkoperInfoTarget.style.display = 'block';
    this.ticketHeight = this.formCard.scrollHeight;

    // Restore organisator
    this.ticketkoperInfoTarget.style.display = 'none';
    this.organisatorFormTarget.style.display = 'block';

    // Restore password rules
    if (passwordRules) {
      passwordRules.style.display = '';
    }

    // Don't set any height initially - natural sizing
  }

  showOrganisator() {
    this.orgBtnTarget.classList.add("active");
    this.buyerBtnTarget.classList.remove("active");

    // Start from current height
    const startHeight = this.formCard.offsetHeight;
    this.formCard.style.height = `${startHeight}px`;
    this.formCard.style.overflow = 'hidden';

    // Switch content
    this.ticketkoperInfoTarget.style.display = 'none';
    this.organisatorFormTarget.style.display = 'block';

    // Get target height
    this.formCard.style.height = 'auto';
    const endHeight = this.formCard.scrollHeight;
    this.formCard.style.height = `${startHeight}px`;

    // Trigger animation
    requestAnimationFrame(() => {
      this.formCard.style.transition = 'height 0.3s ease-out';
      this.formCard.style.height = `${endHeight}px`;
    });

    // Clean up after animation
    setTimeout(() => {
      this.formCard.style.height = '';
      this.formCard.style.overflow = '';
      this.formCard.style.transition = '';
    }, 300);
  }

  showTicketkoper() {
    this.orgBtnTarget.classList.remove("active");
    this.buyerBtnTarget.classList.add("active");

    // Start from current height
    const startHeight = this.formCard.offsetHeight;
    this.formCard.style.height = `${startHeight}px`;
    this.formCard.style.overflow = 'hidden';

    // Switch content
    this.organisatorFormTarget.style.display = 'none';
    this.ticketkoperInfoTarget.style.display = 'block';

    // Get target height
    this.formCard.style.height = 'auto';
    const endHeight = this.formCard.scrollHeight;
    this.formCard.style.height = `${startHeight}px`;

    // Trigger animation
    requestAnimationFrame(() => {
      this.formCard.style.transition = 'height 0.3s ease-out';
      this.formCard.style.height = `${endHeight}px`;
    });

    // Clean up after animation
    setTimeout(() => {
      this.formCard.style.height = '';
      this.formCard.style.overflow = '';
      this.formCard.style.transition = '';
    }, 300);
  }
}
